import t from"react";import a from"./components/TabBar/TabBar.js";const e=({fullWidthTabs:e,testId:r,...o})=>t.createElement(a,{"data-testid":r,fullWidthTabs:e,...o});export{e as default};
//# sourceMappingURL=HeaderTabs.js.map
